exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".voceEccezione{color:red !important}.voceTree{padding:5px}.grigliapermessimoduli input[type=checkbox]{float:left;margin:0 auto;width:100%}", ""]);

// exports
